import Joi from 'joi';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getAffirmativeOptions } from '../../../utils/data';
import { NewPCNLItem } from '../../../utils/models';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class NewPCNLItemForm extends Form {
	state = {
		data: { 
            pcnlItemName: '',
            hasUTMData: '',
            hasMPTData: '',
            hasLPTData: '',
            hasConcreteData: '',
         },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
        pcnlItemOptions: [],
	};

	schema = {
		pcnlItemName: Joi.string().required().label('PCNL Item Name'),
        hasUTMData: Joi.string().required().label('Has UTM Data'),
        hasMPTData: Joi.string().required().label('Has MPT Data'),
        hasLPTData: Joi.string().required().label('Has LPT Data'),
        hasConcreteData: Joi.string().required().label('Has Concrete Hammer Data')
	};

    static propTypes = {
        itemsToExclude: PropTypes.array,
    }

    componentDidMount() {
        if (this.props.itemsToExclude && this.props.itemsToExclude.length > 0) {
            this.mapUpdatedInspectionItems();
        } else {
            this.mapAllInspectionItems();
        }
    }

    componentDidUpdate(prevProps: { itemsToExclude: string[]; }, prevState: { data: NewPCNLItem }) {
        if (this.props.itemsToExclude) {
            if (this.props.itemsToExclude.length === 0 || prevProps.itemsToExclude === this.props.itemsToExclude) return;
            
            this.mapUpdatedInspectionItems();
        }
    }

    mapUpdatedInspectionItems = () => {
        const currentOptions = _.difference(PCNL_INSPECTION_ITEMS, this.props.itemsToExclude).map(inspectionItem => ({ id: inspectionItem, name: inspectionItem }));
        this.setState({ pcnlItemOptions: currentOptions } as any);
    };

    mapAllInspectionItems = () => {
        const pcnlItemOptions = PCNL_INSPECTION_ITEMS.map(inspectionItem => ({ id: inspectionItem, name: inspectionItem }));
        this.setState({ pcnlItemOptions } as any);
    };

	doSubmit = () => {
		this.props.onAdd(this.state.data);
		toastService.success('Saved successfully!');

        this.setState({ 
            data: { 
                pcnlItemName: '',
                hasUTMData: '',
                hasMPTData: '',
                hasLPTData: '',
                hasConcreteData: ''
            }
        });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderSelect({
					name: 'pcnlItemName',
					label: 'PCNL Item Name',
					placeholder: 'Select PCNL Item Name',
                    options: this.state.pcnlItemOptions,
				})}

                <div className="divider my-4"></div>

                <div className="row">
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasUTMData',
                            label: 'Has UTM Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasMPTData',
                            label: 'Has MPT Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasLPTData',
                            label: 'Has LPT Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasConcreteData',
                            label: 'Has Concrete Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                </div>

				<div className="mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add PCNL Item')}
				</div>
			</form>
		);
	}
}

const PCNL_INSPECTION_ITEMS = [
    'General Inspection',
    'Material Assessment',
    'Corrosion Inspection',
    'Regulatory Compliance',
    'Safety Assessment',
    'Risk Assessment',
    'Maintenance Practices',
    'Foundation Assessment',
    'Coating Inspection',
    'Structural Stability Analysis',
];

export default NewPCNLItemForm;
